// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27 viewBox=%270 0 24 24%27><circle cx=%2711%27 cy=%2711%27 r=%277%27/><path d=%27M20 20l-3.5-3.5%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * dashboard_v2.css
 * ----------------
 * Capes noves de la interfície (prova, inspirada en Idees imatge/* v2.png).
 * No redefineix classes de dashboard.css. Les pàgines migrades han d'usar
 * aquests noms i embolicar el contingut amb .dv2.
 *
 * Ús:
 *   import "../dashboard_v2.css";
 *   <div className="dv2">...</div>
 *
 * El menú principal (.dv2-nav) el pinta Dashboard.js. Les pantalles velles
 * (dashboard.css) conviuen a sota; no redefinir .menu-bar des d'aquí.
 */

/* ============================================================
   Tokens
   (També a :root perquè els menús portaled a document.body
   no queden dins .dv2 i, si no, el fons surt transparent.)
   ============================================================ */

:root,
.dv2 {
  --dv2-bg: #f4f6fb;
  --dv2-surface: #ffffff;
  --dv2-surface-muted: #f8fafc;
  --dv2-text: #0f172a;
  --dv2-text-muted: #64748b;
  --dv2-border: #e2e8f0;
  --dv2-border-strong: #cbd5e1;
  --dv2-primary: #2563eb;
  --dv2-primary-hover: #1d4ed8;
  --dv2-primary-soft: #eff6ff;
  --dv2-danger: #dc2626;
  --dv2-danger-hover: #b91c1c;
  --dv2-danger-soft: #fef2f2;
  --dv2-success: #16a34a;
  --dv2-success-soft: #f0fdf4;
  --dv2-warning: #d97706;
  --dv2-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  --dv2-shadow-md: 0 8px 24px rgba(15, 23, 42, 0.08);
  --dv2-radius: 12px;
  --dv2-radius-sm: 8px;
  --dv2-nav-h: 56px;
  --dv2-font: "Segoe UI", system-ui, -apple-system, Arial, sans-serif;
  --dv2-focus: 0 0 0 3px rgba(37, 99, 235, 0.28);

  /* Subtaules per profunditat (cicle de 4, com un mapa):
     nivell 1 vermellós, 2 verdós, 3 ambre, 4 violat. El 5 torna al 1.
     Diferencia pare–fill; els germans del mateix nivell comparteixen color. */
  --dv2-nest-1-head: #fad4d4;
  --dv2-nest-1-odd: #fff1f1;
  --dv2-nest-1-even: #fde2e2;
  --dv2-nest-1-hover: #f6b8b8;
  --dv2-nest-1-selected: #ee9b9b;
  --dv2-nest-1-border: #e8a3a3;
  --dv2-nest-1-ink: #7f1d1d;
  --dv2-nest-2-head: #cfe8d6;
  --dv2-nest-2-odd: #f3faf5;
  --dv2-nest-2-even: #dff3e6;
  --dv2-nest-2-hover: #b4dcc3;
  --dv2-nest-2-selected: #8fcaa6;
  --dv2-nest-2-border: #8fc9a0;
  --dv2-nest-2-ink: #14532d;
  --dv2-nest-3-head: #f6e3b8;
  --dv2-nest-3-odd: #fff8e8;
  --dv2-nest-3-even: #f8edcc;
  --dv2-nest-3-hover: #efd089;
  --dv2-nest-3-selected: #e4c15f;
  --dv2-nest-3-border: #e0c070;
  --dv2-nest-3-ink: #7c4a03;
  --dv2-nest-4-head: #ddd4f5;
  --dv2-nest-4-odd: #f6f3fd;
  --dv2-nest-4-even: #e9e2f8;
  --dv2-nest-4-hover: #cbbef0;
  --dv2-nest-4-selected: #b5a3e8;
  --dv2-nest-4-border: #b8a8e0;
  --dv2-nest-4-ink: #4c1d95;
}

.dv2 {
  color: var(--dv2-text);
  font-family: var(--dv2-font);
  font-size: 14px;
  line-height: 1.45;
  background: var(--dv2-bg);
  box-sizing: border-box;
}

.dv2 *,
.dv2 *::before,
.dv2 *::after {
  box-sizing: border-box;
}

.dv2 button,
.dv2 input,
.dv2 select,
.dv2 textarea {
  font-family: inherit;
}

/* ============================================================
   Shell / menú principal (Dashboard.js)
   Alçada 56px, propera a l'antiga de 50px, per no trencar
   el calc(100vh - 262px) de les pàgines que encara usen dashboard.css.
   ============================================================ */

.dv2-nav,
.dv2-nav * {
  box-sizing: border-box;
}

.dv2-nav {
  position: relative;
  z-index: 50;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: var(--dv2-nav-h);
  height: var(--dv2-nav-h);
  padding: 0 16px;
  background: var(--dv2-surface);
  border-bottom: 1px solid var(--dv2-border);
  box-shadow: var(--dv2-shadow);
  flex-shrink: 0;
}

.dv2-nav--pestanya {
  justify-content: space-between;
}

.dv2-nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.02em;
  color: var(--dv2-text);
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
}

.dv2-nav-logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
  background: #fff;
}

.dv2-nav-brand-name {
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.02em;
}

.dv2-nav-caret {
  margin-left: 4px;
  font-size: 10px;
  opacity: 0.7;
}

.dv2-nav-list {
  display: flex;
  align-items: stretch;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
  height: 100%;
  overflow: visible;
}

.dv2-nav-item,
.dv2-nav-dropdown > .dv2-nav-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 100%;
  padding: 0 12px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  white-space: nowrap;
}

.dv2-nav-item:hover {
  color: var(--dv2-text);
}

.dv2-nav-item.is-active {
  color: var(--dv2-primary);
  font-weight: 650;
  border-bottom-color: var(--dv2-primary);
}

.dv2-nav-dropdown {
  position: relative;
  height: 100%;
  display: flex;
  align-items: stretch;
}

.dv2-nav-menu {
  display: none;
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  min-width: 200px;
  padding: 6px;
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius-sm);
  box-shadow: var(--dv2-shadow-md);
  z-index: 40;
}

.dv2-nav-dropdown.is-open .dv2-nav-menu {
  display: block;
}

@media (hover: hover) and (pointer: fine) {
  .dv2-nav-dropdown:hover .dv2-nav-menu {
    display: block;
  }
}

.dv2-nav-subitem {
  display: block;
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  color: var(--dv2-text);
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.dv2-nav-subitem:hover {
  background: var(--dv2-primary-soft);
  color: var(--dv2-primary-hover);
}

.dv2-nav-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

.dv2-nav-icon {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #475569;
  cursor: pointer;
}

.dv2-nav-icon:hover {
  background: var(--dv2-bg);
  color: var(--dv2-text);
}

.dv2-nav-icon svg {
  width: 15px;
  height: 15px;
}

.dv2-nav-user {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 4px;
  border: 1px solid var(--dv2-border);
  border-radius: 999px;
  background: var(--dv2-surface);
  cursor: pointer;
  color: var(--dv2-text);
  font-size: 13px;
  font-weight: 600;
}

.dv2-nav-avatar {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--dv2-primary);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.dv2-nav-user-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  line-height: 1.2;
}

.dv2-nav-user-name,
.dv2-nav-user-empresa {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
}

.dv2-nav-user-empresa {
  font-size: 11px;
  font-weight: 500;
  color: var(--dv2-text-muted);
}

.dv2-nav-logout {
  color: var(--dv2-danger);
}

.dv2-nav-logout:hover {
  background: var(--dv2-danger-soft);
  color: var(--dv2-danger-hover);
}

.dv2-nav-logout-text {
  font-size: 13px;
  font-weight: 600;
}

.dv2-nav-burger {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  border: 1px solid var(--dv2-border);
  border-radius: 8px;
  background: var(--dv2-surface);
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

.dv2-nav-burger-line {
  display: block;
  width: 16px;
  height: 2px;
  border-radius: 1px;
  background: var(--dv2-text);
}

.dv2-nav.is-open .dv2-nav-burger-line:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.dv2-nav.is-open .dv2-nav-burger-line:nth-child(2) {
  opacity: 0;
}

.dv2-nav.is-open .dv2-nav-burger-line:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.dv2-nav-scrim {
  display: none;
}

/* ============================================================
   Pàgina
   ============================================================ */

.dv2-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
  padding: 20px 24px 28px;
}

/* Llista: capçalera + taula + paginació dins de la pantalla, sense scroll del .content */
.dv2-page--fill {
  height: calc(100vh - 96px); /* menú 56 + padding .content 40 */
  max-height: calc(100vh - 96px);
  overflow: hidden;
  padding: 16px 20px 12px;
}

.dv2-listBody {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dv2-page--fill .dv2-listBody > .dv2-tableWrap,
.dv2-page--fill .dv2-listBody > .dv2-recordList {
  flex: 1 1;
  min-height: 0;
  max-height: none;
  overflow: auto;
}

.dv2-page--fill .dv2-entity-body > .dv2-recordList,
.dv2-page--fill .dv2-entity-body > .dv2-tableWrap {
  flex: 1 1 auto;
  min-height: 12rem;
}

.dv2-page--fill .dv2-pagination {
  flex-shrink: 0;
}

.dv2-page--fill .dv2-empty {
  flex: 1 1;
}

.dv2-pageHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.dv2-pageHeader-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.dv2-pageHeader-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--dv2-primary-soft);
  color: var(--dv2-primary);
  font-size: 18px;
}

.dv2-pageHeader-icon.is-danger {
  background: var(--dv2-danger-soft);
  color: var(--dv2-danger);
}

.dv2-pageHeader-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--dv2-text);
}

.dv2-pageHeader-subtitle {
  margin: 2px 0 0;
  color: var(--dv2-text-muted);
  font-size: 13px;
}

.dv2-pageHeader-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

/* ============================================================
   Botons
   ============================================================ */

.dv2-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid var(--dv2-border);
  background: var(--dv2-surface);
  color: var(--dv2-text);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: var(--dv2-shadow);
}

.dv2-btn:hover {
  background: var(--dv2-surface-muted);
}

.dv2-btn:focus-visible,
.dv2-nav-item:focus-visible,
.dv2-input:focus-visible,
.dv2-select:focus-visible,
.dv2-textarea:focus-visible {
  outline: none;
  box-shadow: var(--dv2-focus);
}

.dv2-btn:disabled,
.dv2-btn.is-disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.dv2-btn--primary {
  background: var(--dv2-primary);
  border-color: var(--dv2-primary);
  color: #fff;
}

.dv2-btn--primary:hover {
  background: var(--dv2-primary-hover);
  border-color: var(--dv2-primary-hover);
}

.dv2-btn--danger {
  background: var(--dv2-danger);
  border-color: var(--dv2-danger);
  color: #fff;
}

.dv2-btn--danger:hover {
  background: var(--dv2-danger-hover);
  border-color: var(--dv2-danger-hover);
}

.dv2-btn--ghost {
  background: transparent;
  box-shadow: none;
}

.dv2-btn--ghost:hover {
  background: var(--dv2-surface-muted);
}

.dv2-btn--icon {
  width: 36px;
  min-height: 36px;
  padding: 0;
}

/* ============================================================
   Filtres / cerca
   ============================================================ */

.dv2-filterBar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  padding: 14px 16px;
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius);
  box-shadow: var(--dv2-shadow);
}

.dv2-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
}

.dv2-filter--grow {
  flex: 1 1 240px;
  min-width: 220px;
}

.dv2-filter--toggle {
  min-width: 140px;
}

.dv2-filter-label {
  font-size: 12px;
  font-weight: 650;
  color: #334155;
}

.dv2-input,
.dv2-select,
.dv2-textarea {
  width: 100%;
  min-height: 38px;
  padding: 8px 12px;
  border: 1px solid var(--dv2-border-strong);
  border-radius: 10px;
  background: var(--dv2-surface);
  color: var(--dv2-text);
  font-size: 14px;
}

.dv2-input::placeholder,
.dv2-textarea::placeholder {
  color: #94a3b8;
}

.dv2-textarea {
  min-height: 84px;
  resize: vertical;
}

.dv2-input.is-placeholder,
.dv2-select.is-placeholder,
.dv2-textarea.is-placeholder {
  color: #94a3b8;
  font-style: italic;
}

.dv2-input.is-readonly,
.dv2-select.is-readonly,
.dv2-textarea.is-readonly {
  background: var(--dv2-surface-muted);
  color: var(--dv2-text-muted);
}

.dv2-input-search {
  padding-left: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 12px 50%;
}

/* ============================================================
   Taula
   ============================================================ */

.dv2-tableWrap {
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius);
  box-shadow: var(--dv2-shadow);
  overflow: auto;
  max-height: calc(100vh - 280px);
}

.dv2-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}

.dv2-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 10px 14px;
  text-align: left;
  font-weight: 650;
  color: #333;
  background: #f4f4f9;
  border-bottom: 2px solid #bdbdbd;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06);
  white-space: nowrap;
  cursor: pointer;
}

.dv2-table th.is-sorted {
  color: var(--dv2-primary);
}

.dv2-table th.dv2-num,
.dv2-table td.dv2-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.dv2-table th:hover {
  background: #e0e0e0;
}

.dv2-table td {
  padding: 11px 14px;
  border-bottom: 1px solid var(--dv2-border);
  white-space: nowrap;
  color: #1e293b;
}

.dv2-table td.dv2-cell-clip {
  max-width: 36rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dv2-table tbody tr:last-child td {
  border-bottom: none;
}

.dv2-table tbody tr:nth-child(odd) td {
  background: #ffffff;
}

.dv2-table tbody tr:nth-child(even) td {
  background: #f9f9f9;
}

.dv2-table tbody tr:hover td {
  background: #d3d3d3;
}

.dv2-table tbody tr.is-selected td {
  background: #cce5ff;
  color: #004085;
  font-weight: 700;
}

.dv2-table tbody tr.is-selected:hover td {
  background: #b3d7ff;
}

.dv2-table tbody tr {
  position: relative;
}

.dv2-table-actions {
  position: relative;
  width: 48px;
  text-align: right;
}

.dv2-table th.dv2-col-expand,
.dv2-table td.dv2-col-expand {
  width: 40px;
  padding-left: 8px;
  padding-right: 4px;
  text-align: center;
  white-space: nowrap;
}

.dv2-table th.dv2-col-expand,
.dv2-table th.dv2-table-actions {
  cursor: default;
}

.dv2-expandBtn {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  font-size: 11px;
  line-height: 1;
}

.dv2-expandBtn:hover,
.dv2-expandBtn.is-open {
  background: var(--dv2-bg);
  color: var(--dv2-text);
}

.dv2-expandBtn.has-children {
  color: var(--dv2-danger);
}

.dv2-expandBtn.has-children:hover,
.dv2-expandBtn.has-children.is-open {
  color: var(--dv2-danger-hover);
  background: var(--dv2-danger-soft);
}

.dv2-table tbody tr.is-open td {
  background: #eef2ff;
  font-weight: 650;
}

.dv2-table tbody tr.dv2-row-nest--1 td {
  background: var(--dv2-nest-1-odd);
}
.dv2-table tbody tr.dv2-row-nest--1:hover td {
  background: var(--dv2-nest-1-hover);
}
.dv2-table tbody tr.dv2-row-nest--1.is-selected td,
.dv2-table tbody tr.dv2-row-nest--1.is-selected:hover td {
  background: var(--dv2-nest-1-selected);
  color: var(--dv2-nest-1-ink);
}
.dv2-table tbody tr.dv2-row-nest--1.is-open td {
  background: var(--dv2-nest-1-head);
}

.dv2-table tbody tr.dv2-row-nest--2 td {
  background: var(--dv2-nest-2-odd);
}
.dv2-table tbody tr.dv2-row-nest--2:hover td {
  background: var(--dv2-nest-2-hover);
}
.dv2-table tbody tr.dv2-row-nest--2.is-selected td,
.dv2-table tbody tr.dv2-row-nest--2.is-selected:hover td {
  background: var(--dv2-nest-2-selected);
  color: var(--dv2-nest-2-ink);
}
.dv2-table tbody tr.dv2-row-nest--2.is-open td {
  background: var(--dv2-nest-2-head);
}

.dv2-table tbody tr.dv2-row-nest--3 td {
  background: var(--dv2-nest-3-odd);
}
.dv2-table tbody tr.dv2-row-nest--3:hover td {
  background: var(--dv2-nest-3-hover);
}
.dv2-table tbody tr.dv2-row-nest--3.is-selected td,
.dv2-table tbody tr.dv2-row-nest--3.is-selected:hover td {
  background: var(--dv2-nest-3-selected);
  color: var(--dv2-nest-3-ink);
}
.dv2-table tbody tr.dv2-row-nest--3.is-open td {
  background: var(--dv2-nest-3-head);
}

.dv2-table tbody tr.dv2-row-nest--4 td {
  background: var(--dv2-nest-4-odd);
}
.dv2-table tbody tr.dv2-row-nest--4:hover td {
  background: var(--dv2-nest-4-hover);
}
.dv2-table tbody tr.dv2-row-nest--4.is-selected td,
.dv2-table tbody tr.dv2-row-nest--4.is-selected:hover td {
  background: var(--dv2-nest-4-selected);
  color: var(--dv2-nest-4-ink);
}
.dv2-table tbody tr.dv2-row-nest--4.is-open td {
  background: var(--dv2-nest-4-head);
}

.dv2-seg {
  display: inline-flex;
  flex-wrap: wrap;
  margin: 0 0 12px;
  border: 1px solid var(--dv2-border);
  border-radius: 10px;
  overflow: hidden;
  background: var(--dv2-surface);
}

.dv2-seg-btn {
  margin: 0;
  border: none;
  border-right: 1px solid var(--dv2-border);
  background: transparent;
  padding: 8px 14px;
  font-weight: 650;
  font-size: 13px;
  color: #64748b;
  cursor: pointer;
}

.dv2-seg-btn:last-child {
  border-right: none;
}

.dv2-seg-btn:hover:not(.is-active) {
  background: var(--dv2-bg);
}

.dv2-seg-btn.is-active {
  background: var(--dv2-primary-soft);
  color: var(--dv2-primary);
}

.dv2-date-prevista {
  font-style: italic;
  color: var(--dv2-text-muted);
}

.dv2-record.dv2-row-nest--1 {
  background: var(--dv2-nest-1-odd);
  border-color: var(--dv2-nest-1-border);
}
.dv2-record.dv2-row-nest--2 {
  background: var(--dv2-nest-2-odd);
  border-color: var(--dv2-nest-2-border);
}
.dv2-record.dv2-row-nest--3 {
  background: var(--dv2-nest-3-odd);
  border-color: var(--dv2-nest-3-border);
}
.dv2-record.dv2-row-nest--4 {
  background: var(--dv2-nest-4-odd);
  border-color: var(--dv2-nest-4-border);
}

.dv2-table tbody tr.is-nested > td {
  padding: 8px 14px 12px 48px;
  background: transparent;
  border-bottom: 1px solid var(--dv2-border);
  font-weight: 400;
  white-space: normal;
}

.dv2-table tbody tr.is-nested:hover > td,
.dv2-table tbody tr.is-nested:nth-child(odd) > td,
.dv2-table tbody tr.is-nested:nth-child(even) > td {
  background: transparent;
}

.dv2-nested {
  --nest-head: var(--dv2-nest-1-head);
  --nest-odd: var(--dv2-nest-1-odd);
  --nest-even: var(--dv2-nest-1-even);
  --nest-hover: var(--dv2-nest-1-hover);
  --nest-selected: var(--dv2-nest-1-selected);
  --nest-border: var(--dv2-nest-1-border);
  --nest-ink: var(--dv2-nest-1-ink);
  background: var(--nest-odd);
  border: 1px solid var(--nest-border);
  border-radius: 10px;
  overflow: hidden;
}

.dv2-nested--1 {
  --nest-head: var(--dv2-nest-1-head);
  --nest-odd: var(--dv2-nest-1-odd);
  --nest-even: var(--dv2-nest-1-even);
  --nest-hover: var(--dv2-nest-1-hover);
  --nest-selected: var(--dv2-nest-1-selected);
  --nest-border: var(--dv2-nest-1-border);
  --nest-ink: var(--dv2-nest-1-ink);
}

.dv2-nested--2 {
  --nest-head: var(--dv2-nest-2-head);
  --nest-odd: var(--dv2-nest-2-odd);
  --nest-even: var(--dv2-nest-2-even);
  --nest-hover: var(--dv2-nest-2-hover);
  --nest-selected: var(--dv2-nest-2-selected);
  --nest-border: var(--dv2-nest-2-border);
  --nest-ink: var(--dv2-nest-2-ink);
}

.dv2-nested--3 {
  --nest-head: var(--dv2-nest-3-head);
  --nest-odd: var(--dv2-nest-3-odd);
  --nest-even: var(--dv2-nest-3-even);
  --nest-hover: var(--dv2-nest-3-hover);
  --nest-selected: var(--dv2-nest-3-selected);
  --nest-border: var(--dv2-nest-3-border);
  --nest-ink: var(--dv2-nest-3-ink);
}

.dv2-nested--4 {
  --nest-head: var(--dv2-nest-4-head);
  --nest-odd: var(--dv2-nest-4-odd);
  --nest-even: var(--dv2-nest-4-even);
  --nest-hover: var(--dv2-nest-4-hover);
  --nest-selected: var(--dv2-nest-4-selected);
  --nest-border: var(--dv2-nest-4-border);
  --nest-ink: var(--dv2-nest-4-ink);
}

.dv2-nested-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 12px;
  background: var(--nest-head);
  border-bottom: 1px solid var(--nest-border);
  font-size: 12px;
  font-weight: 650;
  color: var(--nest-ink);
}

.dv2-nested .dv2-table {
  font-size: 12px;
}

.dv2-nested .dv2-table th {
  position: static;
  box-shadow: none;
  cursor: pointer;
  padding: 8px 10px;
  background: var(--nest-head);
  color: var(--nest-ink);
  border-bottom-color: var(--nest-border);
}

.dv2-nested .dv2-table th.dv2-table-actions {
  cursor: default;
}

.dv2-nested .dv2-table th:hover {
  background: var(--nest-hover);
}

.dv2-nested .dv2-table th.dv2-table-actions:hover {
  background: var(--nest-head);
}

.dv2-nested .dv2-table th.is-sorted {
  color: var(--dv2-primary);
}

.dv2-nested .dv2-table td {
  padding: 8px 10px;
}

.dv2-nested .dv2-table tbody tr:nth-child(odd) td {
  background: var(--nest-odd);
}

.dv2-nested .dv2-table tbody tr:nth-child(even) td {
  background: var(--nest-even);
}

.dv2-nested .dv2-table tbody tr:hover td {
  background: var(--nest-hover);
}

.dv2-nested .dv2-table tbody tr.is-selected td {
  background: var(--nest-selected);
  color: var(--nest-ink);
}

.dv2-nested .dv2-table tbody tr.is-selected:hover td {
  background: var(--nest-hover);
}

.dv2-nested .dv2-empty {
  border: none;
  box-shadow: none;
  padding: 16px 12px;
  background: var(--nest-odd);
  color: var(--nest-ink);
}

.dv2-record-children {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: -2px 0 10px 12px;
  padding-left: 12px;
  border-left: 3px solid var(--nest-border, var(--dv2-border));
}

.dv2-record-children.dv2-nested--1 {
  --nest-head: var(--dv2-nest-1-head);
  --nest-odd: var(--dv2-nest-1-odd);
  --nest-even: var(--dv2-nest-1-even);
  --nest-hover: var(--dv2-nest-1-hover);
  --nest-selected: var(--dv2-nest-1-selected);
  --nest-border: var(--dv2-nest-1-border);
  --nest-ink: var(--dv2-nest-1-ink);
}

.dv2-record-children.dv2-nested--2 {
  --nest-head: var(--dv2-nest-2-head);
  --nest-odd: var(--dv2-nest-2-odd);
  --nest-even: var(--dv2-nest-2-even);
  --nest-hover: var(--dv2-nest-2-hover);
  --nest-selected: var(--dv2-nest-2-selected);
  --nest-border: var(--dv2-nest-2-border);
  --nest-ink: var(--dv2-nest-2-ink);
}

.dv2-record-children.dv2-nested--3 {
  --nest-head: var(--dv2-nest-3-head);
  --nest-odd: var(--dv2-nest-3-odd);
  --nest-even: var(--dv2-nest-3-even);
  --nest-hover: var(--dv2-nest-3-hover);
  --nest-selected: var(--dv2-nest-3-selected);
  --nest-border: var(--dv2-nest-3-border);
  --nest-ink: var(--dv2-nest-3-ink);
}

.dv2-record-children.dv2-nested--4 {
  --nest-head: var(--dv2-nest-4-head);
  --nest-odd: var(--dv2-nest-4-odd);
  --nest-even: var(--dv2-nest-4-even);
  --nest-hover: var(--dv2-nest-4-hover);
  --nest-selected: var(--dv2-nest-4-selected);
  --nest-border: var(--dv2-nest-4-border);
  --nest-ink: var(--dv2-nest-4-ink);
}

.dv2-record-children .dv2-record {
  box-shadow: none;
  background: var(--nest-odd, #f8fafc);
  border-color: var(--nest-border, var(--dv2-border));
}

.dv2-record-children .dv2-record:hover {
  background: var(--nest-hover, #e2e8f0);
}

.dv2-record-children .dv2-record.is-selected {
  background: var(--nest-selected, #cce5ff);
}

.dv2-empty {
  margin: 0;
  padding: 28px 16px;
  text-align: center;
  color: var(--dv2-text-muted);
  background: var(--dv2-surface);
  border: 1px dashed var(--dv2-border);
  border-radius: var(--dv2-radius);
}

.dv2-menuBtn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.dv2-menuBtn:hover,
.dv2-menuBtn.is-open {
  background: var(--dv2-bg);
  color: var(--dv2-text);
}

.dv2-menu {
  position: absolute;
  right: 8px;
  z-index: 400;
  min-width: 200px;
  padding: 6px;
  background: #ffffff;
  background: var(--dv2-surface, #ffffff);
  border: 1px solid var(--dv2-border, #e2e8f0);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
}

.dv2-menu--fixed {
  position: fixed;
  right: auto;
  z-index: 400;
}

.dv2-menu-item {
  display: block;
  width: 100%;
  padding: 8px 10px;
  text-align: left;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--dv2-text);
  font-size: 13px;
}

.dv2-menu-item:hover {
  background: var(--dv2-primary-soft);
}

.dv2-menu-item.is-danger {
  color: var(--dv2-danger);
}

.dv2-menu-item.is-danger:hover {
  background: var(--dv2-danger-soft);
}

/* Llista tipus targeta (mòbil / tauleta estreta) */
.dv2-recordList {
  display: none;
  flex-direction: column;
  gap: 10px;
}

.dv2-record {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius);
  box-shadow: var(--dv2-shadow);
}

.dv2-record-title {
  margin: 0 0 4px;
  font-weight: 700;
}

.dv2-record-meta {
  color: var(--dv2-text-muted);
  font-size: 12px;
}

/* ============================================================
   Paginació
   ============================================================ */

.dv2-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 2px 0;
  color: var(--dv2-text-muted);
  font-size: 13px;
}

.dv2-pagination-pages {
  display: flex;
  align-items: center;
  gap: 4px;
}

.dv2-pageBtn {
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #334155;
  cursor: pointer;
  font-weight: 600;
}

.dv2-pageBtn:hover {
  background: #e2e8f0;
}

.dv2-pageBtn.is-active {
  background: var(--dv2-primary);
  color: #fff;
}

.dv2-pageBtn:disabled {
  opacity: 0.35;
  cursor: default;
}

.dv2-pageBtn--nav {
  min-width: 40px;
  height: 40px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

/* ============================================================
   Fitxa / formulari (Consultar, Nou, Esborrar)
   ============================================================ */

.dv2-entity {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Fitxa dins --fill: capçalera, pestanyes i botons fixos; scroll només del cos. */
.dv2-page--fill > .dv2-entity {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.dv2-page--fill > .dv2-entity > .dv2-pageHeader,
.dv2-page--fill > .dv2-entity > .dv2-subnav,
.dv2-page--fill > .dv2-entity > .dv2-banner {
  flex-shrink: 0;
}

.dv2-entity-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dv2-page--fill .dv2-entity-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
}

.dv2-entity-dock {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid var(--dv2-border);
  background: var(--dv2-bg);
}

.dv2-page--fill .dv2-entity-dock .dv2-recordNav,
.dv2-page--fill .dv2-entity-dock .dv2-footerActions {
  padding-top: 0;
}

.dv2-grid {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 16px;
}

.dv2-split {
  display: grid;
  grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.dv2-split .dv2-record {
  width: 100%;
  margin-bottom: 8px;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
  flex-direction: column;
  align-items: flex-start;
}

.dv2-split .dv2-record.is-selected {
  background: #cce5ff;
  border-color: #004085;
}

.dv2-split-tools {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.dv2-split-tools .dv2-btn--mode {
  margin-left: auto;
  padding-left: 10px;
  padding-right: 10px;
}

@media (max-width: 800px) {
  .dv2-split {
    grid-template-columns: 1fr;
  }
}

.dv2-grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.dv2-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.dv2-span-2 {
  grid-column: 1 / -1;
}

.dv2-card {
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius);
  box-shadow: var(--dv2-shadow);
  padding: 16px 18px 18px;
}

.dv2-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.dv2-card-num {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--dv2-primary);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.dv2-card-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
}

.dv2-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px 14px;
}

.dv2-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.dv2-field--wide {
  grid-column: 1 / -1;
}

.dv2-field--long {
  grid-column: span 2;
}

/* Mides semàntiques de fitxa v2. El grid uniforme de .dv2-fields (sense --sizes)
   es queda per layouts especials, no per formularis de fitxa.
   curt: número, pis, porta, CP, escala, dies, flags
   mig: telèfon, cognom, població, dates, selects curts (defecte)
   llarg: email, nom de via, web, nom comercial, selects amb botó +
   ample: descripcions / fila sencera */
.dv2-fields--sizes {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.dv2-fields--sizes .dv2-field {
  flex: 0 1 14rem;
  max-width: 20rem;
}

.dv2-fields--sizes .dv2-field--curt {
  flex: 0 1 9rem;
  max-width: 13rem;
}

.dv2-fields--sizes .dv2-field--mig {
  flex: 0 1 14rem;
  max-width: 20rem;
}

.dv2-fields--sizes .dv2-field--llarg,
.dv2-fields--sizes .dv2-field--long {
  flex: 1 1 22rem;
  max-width: 34rem;
}

.dv2-fields--sizes .dv2-field--ample,
.dv2-fields--sizes .dv2-field--wide {
  flex: 1 1 100%;
  max-width: none;
}

.dv2-fields--sizes .dv2-fields-break {
  flex: 1 1 100%;
  height: 0;
  margin: 0;
  pointer-events: none;
}

.dv2-path {
  margin: 0 0 12px;
  font-size: 13px;
  color: var(--dv2-text-muted);
}

.dv2-path strong {
  color: var(--dv2-text);
  font-weight: 700;
}

.dv2-hint {
  margin: 0 0 10px;
  font-size: 12px;
  color: var(--dv2-text-muted);
}

.dv2-hint--clipStart {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  direction: rtl;
  text-align: left;
}

.dv2-hint--clipStart > span {
  direction: ltr;
  unicode-bidi: isolate;
}

.dv2-imagePreview {
  display: block;
  max-width: min(280px, 100%);
  max-height: 180px;
  object-fit: contain;
  border: 1px solid var(--dv2-border);
  border-radius: 10px;
  background: #fff;
  margin-bottom: 8px;
}

.dv2-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 14px;
  font-size: 12px;
}

.dv2-steps span {
  padding: 3px 8px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #64748b;
}

.dv2-steps span.is-active {
  background: var(--dv2-primary);
  color: #fff;
  font-weight: 700;
}

.dv2-modal--wide {
  width: min(640px, 100%);
  max-height: min(86vh, 720px);
  overflow-y: auto;
}

.dv2-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.dv2-modal-head .dv2-modal-title {
  flex: 1 1;
  min-width: 0;
  padding-top: 4px;
}

.dv2-modal--wide > .dv2-modal-head {
  position: sticky;
  top: -20px;
  z-index: 2;
  background: var(--dv2-surface);
  margin: -20px -22px 12px;
  padding: 16px 14px 12px 22px;
  border-bottom: 1px solid var(--dv2-border);
}

.dv2-controlRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.dv2-controlRow .dv2-select,
.dv2-controlRow .dv2-input,
.dv2-controlRow .dv2-value {
  flex: 1 1;
  min-width: 0;
}

.dv2-btn--compact {
  min-height: 38px;
  padding: 6px 10px;
  font-size: 13px;
}

.dv2-modalOverlay {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
}

.dv2-modal {
  width: min(420px, 100%);
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius);
  box-shadow: var(--dv2-shadow-md);
  padding: 20px 22px 18px;
}

.dv2-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.dv2-modal-lead {
  margin: 6px 0 16px;
  color: var(--dv2-text-muted);
  font-size: 13px;
  line-height: 1.4;
}

.dv2-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
}

.dv2-help {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dv2-help-section h4 {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: var(--dv2-text);
}

.dv2-help-section p,
.dv2-help-section li {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--dv2-text-muted);
}

.dv2-help-section p + p,
.dv2-help-section p + ul {
  margin-top: 6px;
}

.dv2-help-section ul {
  margin: 0;
  padding-left: 1.2rem;
}

.dv2-help-section li + li {
  margin-top: 4px;
}

.dv2-hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--dv2-text-muted);
}

.dv2-combo {
  position: relative;
  width: 100%;
  min-width: 0;
}

.dv2-combo-list {
  position: absolute;
  z-index: 30;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 220px;
  overflow-y: auto;
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border-strong);
  border-radius: var(--dv2-radius-sm);
  box-shadow: var(--dv2-shadow-md);
}

.dv2-combo-option {
  padding: 8px 12px;
  cursor: pointer;
}

.dv2-combo-option:hover,
.dv2-combo-option.is-active {
  background: var(--dv2-primary-soft);
}

.dv2-label {
  font-size: 12px;
  font-weight: 650;
  color: #334155;
}

.dv2-value {
  min-height: 22px;
  color: var(--dv2-text);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.dv2-required::after {
  content: " *";
  color: var(--dv2-danger);
}

.dv2-toggleRow {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
}

.dv2-toggleGroup {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 28px;
  min-height: 38px;
}

.dv2-toggle {
  position: relative;
  width: 42px;
  height: 24px;
  flex-shrink: 0;
}

.dv2-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.dv2-toggle-track {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.dv2-toggle-track::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #fff;
  box-shadow: var(--dv2-shadow);
  transition: transform 0.15s ease;
}

.dv2-toggle input:checked + .dv2-toggle-track {
  background: var(--dv2-primary);
}

.dv2-toggle input:checked + .dv2-toggle-track::after {
  transform: translateX(18px);
}

.dv2-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 650;
  background: var(--dv2-bg);
  color: #334155;
}

.dv2-chip--ok {
  background: var(--dv2-success-soft);
  color: #166534;
}

.dv2-chip--warn {
  background: #fffbeb;
  color: #92400e;
}

.dv2-chip--danger {
  background: var(--dv2-danger-soft);
  color: #991b1b;
}

/* Miniatura d'imatge de recurs (Vehicles, Eines, Magatzems) */
.dv2-thumb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: 1px solid var(--dv2-border);
  border-radius: 8px;
  background: var(--dv2-bg);
  color: var(--dv2-text-muted);
  font-size: 18px;
  overflow: hidden;
}

.dv2-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dv2-record-head {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.dv2-imageField {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.dv2-imageField .dv2-imagePreview {
  margin-bottom: 0;
}

.dv2-banner--info {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1e3a8a;
}

.dv2-table tbody tr.is-inactive td {
  color: var(--dv2-text-muted);
}

.dv2-banner {
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  border-radius: var(--dv2-radius);
  border: 1px solid transparent;
  font-size: 13px;
}

.dv2-banner--danger {
  background: var(--dv2-danger-soft);
  border-color: #fecaca;
  color: #991b1b;
}

.dv2-contactPick {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: var(--dv2-surface);
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius);
}

.dv2-contactPick-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid var(--dv2-border);
  border-radius: 10px;
  background: var(--dv2-surface-muted);
}

.dv2-footerActions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 8px;
}

.dv2-recordNav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding-top: 4px;
}

.dv2-recordNav-btn {
  min-width: 44px;
  min-height: 44px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  padding: 0;
}

.dv2-recordNav-info {
  min-width: 4.5rem;
  text-align: center;
  color: var(--dv2-text-muted);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.dv2-subnav {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 0 4px;
  border-bottom: 1px solid var(--dv2-border);
}

.dv2-subnav-btn {
  appearance: none;
  border: none;
  background: none;
  padding: 10px 14px;
  margin-bottom: -1px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.dv2-subnav-btn:hover {
  color: var(--dv2-text);
}

.dv2-subnav-btn:disabled {
  color: #94a3b8;
  cursor: not-allowed;
  opacity: 0.55;
}

.dv2-subnav-btn:disabled:hover {
  color: #94a3b8;
}

.dv2-subnav-btn.is-active {
  color: var(--dv2-primary);
  border-bottom-color: var(--dv2-primary);
}

.dv2-specList {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid var(--dv2-border);
  border-radius: var(--dv2-radius);
  overflow: hidden;
  background: var(--dv2-surface);
}

.dv2-spec {
  display: grid;
  grid-template-columns: minmax(140px, 1.2fr) minmax(160px, 1.4fr);
  gap: 8px 16px;
  padding: 10px 14px;
  align-items: baseline;
  border-bottom: 1px solid var(--dv2-border);
}

.dv2-spec:nth-child(even) {
  background: var(--dv2-surface-muted);
}

.dv2-spec:last-child {
  border-bottom: none;
}

.dv2-spec-name {
  font-weight: 650;
  color: #334155;
}

.dv2-spec-value {
  color: var(--dv2-text);
  font-variant-numeric: tabular-nums;
}

.dv2-spec-unit {
  color: var(--dv2-text-muted);
  font-weight: 600;
}

.dv2-editorRow {
  display: grid;
  grid-template-columns: minmax(160px, 1.4fr) minmax(90px, 0.7fr) minmax(70px, 0.5fr) minmax(70px, 0.5fr) 90px 40px;
  gap: 8px;
  align-items: end;
  padding: 8px 0;
  border-bottom: 1px solid var(--dv2-border);
}

.dv2-editorRow .dv2-field {
  min-width: 0;
}

@media (max-width: 900px) {
  .dv2-spec,
  .dv2-editorRow {
    grid-template-columns: 1fr 1fr;
  }
}

/* ============================================================
   Adaptació (escriptori estret / tauleta / mòbil)
   El menú hamburguesa cal JS; aquí només amaga/ensenya.
   ============================================================ */

@media (max-width: 1400px) {
  .dv2-nav-burger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .dv2-nav-list {
    display: none;
  }

  .dv2-nav-scrim {
    display: block;
    position: fixed;
    inset: var(--dv2-nav-h) 0 0 0;
    background: rgba(15, 23, 42, 0.28);
    z-index: 25;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .dv2-nav.is-open .dv2-nav-list {
    display: flex;
    position: absolute;
    top: var(--dv2-nav-h);
    left: 0;
    right: 0;
    height: auto;
    max-height: calc(100vh - var(--dv2-nav-h));
    overflow-y: auto;
    flex-direction: column;
    align-items: stretch;
    padding: 8px;
    background: var(--dv2-surface);
    border-bottom: 1px solid var(--dv2-border);
    box-shadow: var(--dv2-shadow-md);
    z-index: 30;
  }

  .dv2-nav.is-open .dv2-nav-item {
    height: 40px;
    justify-content: flex-start;
    border-bottom: none;
    border-radius: 8px;
  }

  .dv2-nav.is-open .dv2-nav-dropdown {
    flex-direction: column;
    height: auto;
    align-items: stretch;
  }

  .dv2-nav.is-open .dv2-nav-dropdown .dv2-nav-menu {
    position: static;
    display: none;
    min-width: 0;
    border: none;
    box-shadow: none;
    padding: 0 0 6px 12px;
  }

  .dv2-nav.is-open .dv2-nav-dropdown.is-open .dv2-nav-menu {
    display: block;
  }

  .dv2-nav.is-open .dv2-nav-dropdown:hover .dv2-nav-menu {
    display: none;
  }

  .dv2-nav.is-open .dv2-nav-dropdown.is-open:hover .dv2-nav-menu {
    display: block;
  }

  .dv2-grid,
  .dv2-grid--3,
  .dv2-grid--4 {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .dv2-page {
    padding: 14px 12px 24px;
  }

  .dv2-page--fill {
    height: calc(100vh - 96px);
    max-height: calc(100vh - 96px);
    padding: 12px 10px 8px;
  }

  .dv2-pageHeader {
    flex-direction: column;
  }

  .dv2-pageHeader-actions,
  .dv2-filterBar {
    width: 100%;
  }

  .dv2-tableWrap {
    display: block;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dv2-recordList {
    display: flex;
  }

  .dv2-grid,
  .dv2-grid--3,
  .dv2-grid--4 {
    grid-template-columns: 1fr;
  }

  .dv2-field--long {
    grid-column: 1 / -1;
  }

  .dv2-fields--sizes .dv2-field:not(.dv2-field--curt) {
    flex: 1 1 100%;
  }

  .dv2-fields--sizes .dv2-field--curt {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 7px);
    max-width: none;
  }

  .dv2-nav-user-text,
  .dv2-nav-brand-name,
  .dv2-nav-logout-text {
    display: none;
  }

  .dv2-nav-logout {
    width: 36px;
    padding: 0;
  }

  .dv2-pagination {
    justify-content: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  .dv2 *,
  .dv2 *::before,
  .dv2 *::after {
    transition: none !important;
  }
}

@media print {
  @page {
    margin: 12mm;
  }

  body {
    background: #fff !important;
  }

  .dv2-nav,
  .menu-bar,
  .action-toolbar,
  .dv2-nav-scrim {
    display: none !important;
  }

  .Dashboard {
    display: block !important;
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
    background: #fff !important;
  }

  .content {
    display: block !important;
    padding: 0 !important;
    border: none !important;
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
    background: #fff !important;
  }

  .dv2-page,
  .dv2-page--fill,
  .dv2-listBody,
  .dv2-tableWrap,
  .dv2-recordList,
  .dv2-entity-body,
  .Dashboard-table-container,
  .Dashboard-content {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .dv2-tableWrap {
    display: block !important;
    box-shadow: none !important;
  }

  .dv2-recordList {
    display: none !important;
  }

  .dv2-table th {
    position: static !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard_v2.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE;;AAEF;;;;iEAIiE;;AAEjE;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,8CAA8C;EAC9C,kDAAkD;EAClD,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,mEAAmE;EACnE,8CAA8C;;EAE9C;;8EAE4E;EAC5E,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;iEAIiE;;AAEjE;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;EACf,8BAA8B;EAC9B,0CAA0C;EAC1C,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,SAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA,yFAAyF;AACzF;EACE,0BAA0B,EAAE,kCAAkC;EAC9D,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;iEAEiE;;AAEjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;EAKE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,yDAAoP;EACpP,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;iEAEiE;;AAEjE;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,yCAAyC;EACzC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;EACjC,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,4CAA4C;EAC5C,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kFAAkF;AAClF;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;uCAKuC;AACvC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,8BAA8B;EAC9B,wBAAwB;EACxB,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,0CAA0C;EAC1C,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iHAAiH;EACjH,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;IAEE,8BAA8B;EAChC;AACF;;AAEA;;;iEAGiE;;AAEjE;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,0CAA0C;IAC1C,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,8BAA8B;IAC9B,0CAA0C;IAC1C,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,eAAe;EACjB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;;IAGE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;;;;;;;IAQE,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/**\n * dashboard_v2.css\n * ----------------\n * Capes noves de la interfície (prova, inspirada en Idees imatge/* v2.png).\n * No redefineix classes de dashboard.css. Les pàgines migrades han d'usar\n * aquests noms i embolicar el contingut amb .dv2.\n *\n * Ús:\n *   import \"../dashboard_v2.css\";\n *   <div className=\"dv2\">...</div>\n *\n * El menú principal (.dv2-nav) el pinta Dashboard.js. Les pantalles velles\n * (dashboard.css) conviuen a sota; no redefinir .menu-bar des d'aquí.\n */\n\n/* ============================================================\n   Tokens\n   (També a :root perquè els menús portaled a document.body\n   no queden dins .dv2 i, si no, el fons surt transparent.)\n   ============================================================ */\n\n:root,\n.dv2 {\n  --dv2-bg: #f4f6fb;\n  --dv2-surface: #ffffff;\n  --dv2-surface-muted: #f8fafc;\n  --dv2-text: #0f172a;\n  --dv2-text-muted: #64748b;\n  --dv2-border: #e2e8f0;\n  --dv2-border-strong: #cbd5e1;\n  --dv2-primary: #2563eb;\n  --dv2-primary-hover: #1d4ed8;\n  --dv2-primary-soft: #eff6ff;\n  --dv2-danger: #dc2626;\n  --dv2-danger-hover: #b91c1c;\n  --dv2-danger-soft: #fef2f2;\n  --dv2-success: #16a34a;\n  --dv2-success-soft: #f0fdf4;\n  --dv2-warning: #d97706;\n  --dv2-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  --dv2-shadow-md: 0 8px 24px rgba(15, 23, 42, 0.08);\n  --dv2-radius: 12px;\n  --dv2-radius-sm: 8px;\n  --dv2-nav-h: 56px;\n  --dv2-font: \"Segoe UI\", system-ui, -apple-system, Arial, sans-serif;\n  --dv2-focus: 0 0 0 3px rgba(37, 99, 235, 0.28);\n\n  /* Subtaules per profunditat (cicle de 4, com un mapa):\n     nivell 1 vermellós, 2 verdós, 3 ambre, 4 violat. El 5 torna al 1.\n     Diferencia pare–fill; els germans del mateix nivell comparteixen color. */\n  --dv2-nest-1-head: #fad4d4;\n  --dv2-nest-1-odd: #fff1f1;\n  --dv2-nest-1-even: #fde2e2;\n  --dv2-nest-1-hover: #f6b8b8;\n  --dv2-nest-1-selected: #ee9b9b;\n  --dv2-nest-1-border: #e8a3a3;\n  --dv2-nest-1-ink: #7f1d1d;\n  --dv2-nest-2-head: #cfe8d6;\n  --dv2-nest-2-odd: #f3faf5;\n  --dv2-nest-2-even: #dff3e6;\n  --dv2-nest-2-hover: #b4dcc3;\n  --dv2-nest-2-selected: #8fcaa6;\n  --dv2-nest-2-border: #8fc9a0;\n  --dv2-nest-2-ink: #14532d;\n  --dv2-nest-3-head: #f6e3b8;\n  --dv2-nest-3-odd: #fff8e8;\n  --dv2-nest-3-even: #f8edcc;\n  --dv2-nest-3-hover: #efd089;\n  --dv2-nest-3-selected: #e4c15f;\n  --dv2-nest-3-border: #e0c070;\n  --dv2-nest-3-ink: #7c4a03;\n  --dv2-nest-4-head: #ddd4f5;\n  --dv2-nest-4-odd: #f6f3fd;\n  --dv2-nest-4-even: #e9e2f8;\n  --dv2-nest-4-hover: #cbbef0;\n  --dv2-nest-4-selected: #b5a3e8;\n  --dv2-nest-4-border: #b8a8e0;\n  --dv2-nest-4-ink: #4c1d95;\n}\n\n.dv2 {\n  color: var(--dv2-text);\n  font-family: var(--dv2-font);\n  font-size: 14px;\n  line-height: 1.45;\n  background: var(--dv2-bg);\n  box-sizing: border-box;\n}\n\n.dv2 *,\n.dv2 *::before,\n.dv2 *::after {\n  box-sizing: border-box;\n}\n\n.dv2 button,\n.dv2 input,\n.dv2 select,\n.dv2 textarea {\n  font-family: inherit;\n}\n\n/* ============================================================\n   Shell / menú principal (Dashboard.js)\n   Alçada 56px, propera a l'antiga de 50px, per no trencar\n   el calc(100vh - 262px) de les pàgines que encara usen dashboard.css.\n   ============================================================ */\n\n.dv2-nav,\n.dv2-nav * {\n  box-sizing: border-box;\n}\n\n.dv2-nav {\n  position: relative;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: var(--dv2-nav-h);\n  height: var(--dv2-nav-h);\n  padding: 0 16px;\n  background: var(--dv2-surface);\n  border-bottom: 1px solid var(--dv2-border);\n  box-shadow: var(--dv2-shadow);\n  flex-shrink: 0;\n}\n\n.dv2-nav--pestanya {\n  justify-content: space-between;\n}\n\n.dv2-nav-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n  color: var(--dv2-text);\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.dv2-nav-logo {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.dv2-nav-brand-name {\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n}\n\n.dv2-nav-caret {\n  margin-left: 4px;\n  font-size: 10px;\n  opacity: 0.7;\n}\n\n.dv2-nav-list {\n  display: flex;\n  align-items: stretch;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n  height: 100%;\n  overflow: visible;\n}\n\n.dv2-nav-item,\n.dv2-nav-dropdown > .dv2-nav-item {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  padding: 0 12px;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.dv2-nav-item:hover {\n  color: var(--dv2-text);\n}\n\n.dv2-nav-item.is-active {\n  color: var(--dv2-primary);\n  font-weight: 650;\n  border-bottom-color: var(--dv2-primary);\n}\n\n.dv2-nav-dropdown {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: stretch;\n}\n\n.dv2-nav-menu {\n  display: none;\n  position: absolute;\n  top: calc(100% - 1px);\n  left: 0;\n  min-width: 200px;\n  padding: 6px;\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius-sm);\n  box-shadow: var(--dv2-shadow-md);\n  z-index: 40;\n}\n\n.dv2-nav-dropdown.is-open .dv2-nav-menu {\n  display: block;\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .dv2-nav-dropdown:hover .dv2-nav-menu {\n    display: block;\n  }\n}\n\n.dv2-nav-subitem {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  text-align: left;\n  color: var(--dv2-text);\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.dv2-nav-subitem:hover {\n  background: var(--dv2-primary-soft);\n  color: var(--dv2-primary-hover);\n}\n\n.dv2-nav-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.dv2-nav-icon {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #475569;\n  cursor: pointer;\n}\n\n.dv2-nav-icon:hover {\n  background: var(--dv2-bg);\n  color: var(--dv2-text);\n}\n\n.dv2-nav-icon svg {\n  width: 15px;\n  height: 15px;\n}\n\n.dv2-nav-user {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 10px 4px 4px;\n  border: 1px solid var(--dv2-border);\n  border-radius: 999px;\n  background: var(--dv2-surface);\n  cursor: pointer;\n  color: var(--dv2-text);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.dv2-nav-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--dv2-primary);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.dv2-nav-user-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n  line-height: 1.2;\n}\n\n.dv2-nav-user-name,\n.dv2-nav-user-empresa {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 160px;\n}\n\n.dv2-nav-user-empresa {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--dv2-text-muted);\n}\n\n.dv2-nav-logout {\n  color: var(--dv2-danger);\n}\n\n.dv2-nav-logout:hover {\n  background: var(--dv2-danger-soft);\n  color: var(--dv2-danger-hover);\n}\n\n.dv2-nav-logout-text {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.dv2-nav-burger {\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--dv2-border);\n  border-radius: 8px;\n  background: var(--dv2-surface);\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.dv2-nav-burger-line {\n  display: block;\n  width: 16px;\n  height: 2px;\n  border-radius: 1px;\n  background: var(--dv2-text);\n}\n\n.dv2-nav.is-open .dv2-nav-burger-line:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.dv2-nav.is-open .dv2-nav-burger-line:nth-child(2) {\n  opacity: 0;\n}\n\n.dv2-nav.is-open .dv2-nav-burger-line:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n.dv2-nav-scrim {\n  display: none;\n}\n\n/* ============================================================\n   Pàgina\n   ============================================================ */\n\n.dv2-page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 0;\n  padding: 20px 24px 28px;\n}\n\n/* Llista: capçalera + taula + paginació dins de la pantalla, sense scroll del .content */\n.dv2-page--fill {\n  height: calc(100vh - 96px); /* menú 56 + padding .content 40 */\n  max-height: calc(100vh - 96px);\n  overflow: hidden;\n  padding: 16px 20px 12px;\n}\n\n.dv2-listBody {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dv2-page--fill .dv2-listBody > .dv2-tableWrap,\n.dv2-page--fill .dv2-listBody > .dv2-recordList {\n  flex: 1;\n  min-height: 0;\n  max-height: none;\n  overflow: auto;\n}\n\n.dv2-page--fill .dv2-entity-body > .dv2-recordList,\n.dv2-page--fill .dv2-entity-body > .dv2-tableWrap {\n  flex: 1 1 auto;\n  min-height: 12rem;\n}\n\n.dv2-page--fill .dv2-pagination {\n  flex-shrink: 0;\n}\n\n.dv2-page--fill .dv2-empty {\n  flex: 1;\n}\n\n.dv2-pageHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.dv2-pageHeader-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.dv2-pageHeader-icon {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--dv2-primary-soft);\n  color: var(--dv2-primary);\n  font-size: 18px;\n}\n\n.dv2-pageHeader-icon.is-danger {\n  background: var(--dv2-danger-soft);\n  color: var(--dv2-danger);\n}\n\n.dv2-pageHeader-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--dv2-text);\n}\n\n.dv2-pageHeader-subtitle {\n  margin: 2px 0 0;\n  color: var(--dv2-text-muted);\n  font-size: 13px;\n}\n\n.dv2-pageHeader-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* ============================================================\n   Botons\n   ============================================================ */\n\n.dv2-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 8px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--dv2-border);\n  background: var(--dv2-surface);\n  color: var(--dv2-text);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: var(--dv2-shadow);\n}\n\n.dv2-btn:hover {\n  background: var(--dv2-surface-muted);\n}\n\n.dv2-btn:focus-visible,\n.dv2-nav-item:focus-visible,\n.dv2-input:focus-visible,\n.dv2-select:focus-visible,\n.dv2-textarea:focus-visible {\n  outline: none;\n  box-shadow: var(--dv2-focus);\n}\n\n.dv2-btn:disabled,\n.dv2-btn.is-disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.dv2-btn--primary {\n  background: var(--dv2-primary);\n  border-color: var(--dv2-primary);\n  color: #fff;\n}\n\n.dv2-btn--primary:hover {\n  background: var(--dv2-primary-hover);\n  border-color: var(--dv2-primary-hover);\n}\n\n.dv2-btn--danger {\n  background: var(--dv2-danger);\n  border-color: var(--dv2-danger);\n  color: #fff;\n}\n\n.dv2-btn--danger:hover {\n  background: var(--dv2-danger-hover);\n  border-color: var(--dv2-danger-hover);\n}\n\n.dv2-btn--ghost {\n  background: transparent;\n  box-shadow: none;\n}\n\n.dv2-btn--ghost:hover {\n  background: var(--dv2-surface-muted);\n}\n\n.dv2-btn--icon {\n  width: 36px;\n  min-height: 36px;\n  padding: 0;\n}\n\n/* ============================================================\n   Filtres / cerca\n   ============================================================ */\n\n.dv2-filterBar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius);\n  box-shadow: var(--dv2-shadow);\n}\n\n.dv2-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 160px;\n}\n\n.dv2-filter--grow {\n  flex: 1 1 240px;\n  min-width: 220px;\n}\n\n.dv2-filter--toggle {\n  min-width: 140px;\n}\n\n.dv2-filter-label {\n  font-size: 12px;\n  font-weight: 650;\n  color: #334155;\n}\n\n.dv2-input,\n.dv2-select,\n.dv2-textarea {\n  width: 100%;\n  min-height: 38px;\n  padding: 8px 12px;\n  border: 1px solid var(--dv2-border-strong);\n  border-radius: 10px;\n  background: var(--dv2-surface);\n  color: var(--dv2-text);\n  font-size: 14px;\n}\n\n.dv2-input::placeholder,\n.dv2-textarea::placeholder {\n  color: #94a3b8;\n}\n\n.dv2-textarea {\n  min-height: 84px;\n  resize: vertical;\n}\n\n.dv2-input.is-placeholder,\n.dv2-select.is-placeholder,\n.dv2-textarea.is-placeholder {\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.dv2-input.is-readonly,\n.dv2-select.is-readonly,\n.dv2-textarea.is-readonly {\n  background: var(--dv2-surface-muted);\n  color: var(--dv2-text-muted);\n}\n\n.dv2-input-search {\n  padding-left: 36px;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%2394a3b8' stroke-width='2' viewBox='0 0 24 24'><circle cx='11' cy='11' r='7'/><path d='M20 20l-3.5-3.5'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: 12px 50%;\n}\n\n/* ============================================================\n   Taula\n   ============================================================ */\n\n.dv2-tableWrap {\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius);\n  box-shadow: var(--dv2-shadow);\n  overflow: auto;\n  max-height: calc(100vh - 280px);\n}\n\n.dv2-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;\n}\n\n.dv2-table th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 10px 14px;\n  text-align: left;\n  font-weight: 650;\n  color: #333;\n  background: #f4f4f9;\n  border-bottom: 2px solid #bdbdbd;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06);\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.dv2-table th.is-sorted {\n  color: var(--dv2-primary);\n}\n\n.dv2-table th.dv2-num,\n.dv2-table td.dv2-num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.dv2-table th:hover {\n  background: #e0e0e0;\n}\n\n.dv2-table td {\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--dv2-border);\n  white-space: nowrap;\n  color: #1e293b;\n}\n\n.dv2-table td.dv2-cell-clip {\n  max-width: 36rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dv2-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.dv2-table tbody tr:nth-child(odd) td {\n  background: #ffffff;\n}\n\n.dv2-table tbody tr:nth-child(even) td {\n  background: #f9f9f9;\n}\n\n.dv2-table tbody tr:hover td {\n  background: #d3d3d3;\n}\n\n.dv2-table tbody tr.is-selected td {\n  background: #cce5ff;\n  color: #004085;\n  font-weight: 700;\n}\n\n.dv2-table tbody tr.is-selected:hover td {\n  background: #b3d7ff;\n}\n\n.dv2-table tbody tr {\n  position: relative;\n}\n\n.dv2-table-actions {\n  position: relative;\n  width: 48px;\n  text-align: right;\n}\n\n.dv2-table th.dv2-col-expand,\n.dv2-table td.dv2-col-expand {\n  width: 40px;\n  padding-left: 8px;\n  padding-right: 4px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.dv2-table th.dv2-col-expand,\n.dv2-table th.dv2-table-actions {\n  cursor: default;\n}\n\n.dv2-expandBtn {\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  font-size: 11px;\n  line-height: 1;\n}\n\n.dv2-expandBtn:hover,\n.dv2-expandBtn.is-open {\n  background: var(--dv2-bg);\n  color: var(--dv2-text);\n}\n\n.dv2-expandBtn.has-children {\n  color: var(--dv2-danger);\n}\n\n.dv2-expandBtn.has-children:hover,\n.dv2-expandBtn.has-children.is-open {\n  color: var(--dv2-danger-hover);\n  background: var(--dv2-danger-soft);\n}\n\n.dv2-table tbody tr.is-open td {\n  background: #eef2ff;\n  font-weight: 650;\n}\n\n.dv2-table tbody tr.dv2-row-nest--1 td {\n  background: var(--dv2-nest-1-odd);\n}\n.dv2-table tbody tr.dv2-row-nest--1:hover td {\n  background: var(--dv2-nest-1-hover);\n}\n.dv2-table tbody tr.dv2-row-nest--1.is-selected td,\n.dv2-table tbody tr.dv2-row-nest--1.is-selected:hover td {\n  background: var(--dv2-nest-1-selected);\n  color: var(--dv2-nest-1-ink);\n}\n.dv2-table tbody tr.dv2-row-nest--1.is-open td {\n  background: var(--dv2-nest-1-head);\n}\n\n.dv2-table tbody tr.dv2-row-nest--2 td {\n  background: var(--dv2-nest-2-odd);\n}\n.dv2-table tbody tr.dv2-row-nest--2:hover td {\n  background: var(--dv2-nest-2-hover);\n}\n.dv2-table tbody tr.dv2-row-nest--2.is-selected td,\n.dv2-table tbody tr.dv2-row-nest--2.is-selected:hover td {\n  background: var(--dv2-nest-2-selected);\n  color: var(--dv2-nest-2-ink);\n}\n.dv2-table tbody tr.dv2-row-nest--2.is-open td {\n  background: var(--dv2-nest-2-head);\n}\n\n.dv2-table tbody tr.dv2-row-nest--3 td {\n  background: var(--dv2-nest-3-odd);\n}\n.dv2-table tbody tr.dv2-row-nest--3:hover td {\n  background: var(--dv2-nest-3-hover);\n}\n.dv2-table tbody tr.dv2-row-nest--3.is-selected td,\n.dv2-table tbody tr.dv2-row-nest--3.is-selected:hover td {\n  background: var(--dv2-nest-3-selected);\n  color: var(--dv2-nest-3-ink);\n}\n.dv2-table tbody tr.dv2-row-nest--3.is-open td {\n  background: var(--dv2-nest-3-head);\n}\n\n.dv2-table tbody tr.dv2-row-nest--4 td {\n  background: var(--dv2-nest-4-odd);\n}\n.dv2-table tbody tr.dv2-row-nest--4:hover td {\n  background: var(--dv2-nest-4-hover);\n}\n.dv2-table tbody tr.dv2-row-nest--4.is-selected td,\n.dv2-table tbody tr.dv2-row-nest--4.is-selected:hover td {\n  background: var(--dv2-nest-4-selected);\n  color: var(--dv2-nest-4-ink);\n}\n.dv2-table tbody tr.dv2-row-nest--4.is-open td {\n  background: var(--dv2-nest-4-head);\n}\n\n.dv2-seg {\n  display: inline-flex;\n  flex-wrap: wrap;\n  margin: 0 0 12px;\n  border: 1px solid var(--dv2-border);\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--dv2-surface);\n}\n\n.dv2-seg-btn {\n  margin: 0;\n  border: none;\n  border-right: 1px solid var(--dv2-border);\n  background: transparent;\n  padding: 8px 14px;\n  font-weight: 650;\n  font-size: 13px;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.dv2-seg-btn:last-child {\n  border-right: none;\n}\n\n.dv2-seg-btn:hover:not(.is-active) {\n  background: var(--dv2-bg);\n}\n\n.dv2-seg-btn.is-active {\n  background: var(--dv2-primary-soft);\n  color: var(--dv2-primary);\n}\n\n.dv2-date-prevista {\n  font-style: italic;\n  color: var(--dv2-text-muted);\n}\n\n.dv2-record.dv2-row-nest--1 {\n  background: var(--dv2-nest-1-odd);\n  border-color: var(--dv2-nest-1-border);\n}\n.dv2-record.dv2-row-nest--2 {\n  background: var(--dv2-nest-2-odd);\n  border-color: var(--dv2-nest-2-border);\n}\n.dv2-record.dv2-row-nest--3 {\n  background: var(--dv2-nest-3-odd);\n  border-color: var(--dv2-nest-3-border);\n}\n.dv2-record.dv2-row-nest--4 {\n  background: var(--dv2-nest-4-odd);\n  border-color: var(--dv2-nest-4-border);\n}\n\n.dv2-table tbody tr.is-nested > td {\n  padding: 8px 14px 12px 48px;\n  background: transparent;\n  border-bottom: 1px solid var(--dv2-border);\n  font-weight: 400;\n  white-space: normal;\n}\n\n.dv2-table tbody tr.is-nested:hover > td,\n.dv2-table tbody tr.is-nested:nth-child(odd) > td,\n.dv2-table tbody tr.is-nested:nth-child(even) > td {\n  background: transparent;\n}\n\n.dv2-nested {\n  --nest-head: var(--dv2-nest-1-head);\n  --nest-odd: var(--dv2-nest-1-odd);\n  --nest-even: var(--dv2-nest-1-even);\n  --nest-hover: var(--dv2-nest-1-hover);\n  --nest-selected: var(--dv2-nest-1-selected);\n  --nest-border: var(--dv2-nest-1-border);\n  --nest-ink: var(--dv2-nest-1-ink);\n  background: var(--nest-odd);\n  border: 1px solid var(--nest-border);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.dv2-nested--1 {\n  --nest-head: var(--dv2-nest-1-head);\n  --nest-odd: var(--dv2-nest-1-odd);\n  --nest-even: var(--dv2-nest-1-even);\n  --nest-hover: var(--dv2-nest-1-hover);\n  --nest-selected: var(--dv2-nest-1-selected);\n  --nest-border: var(--dv2-nest-1-border);\n  --nest-ink: var(--dv2-nest-1-ink);\n}\n\n.dv2-nested--2 {\n  --nest-head: var(--dv2-nest-2-head);\n  --nest-odd: var(--dv2-nest-2-odd);\n  --nest-even: var(--dv2-nest-2-even);\n  --nest-hover: var(--dv2-nest-2-hover);\n  --nest-selected: var(--dv2-nest-2-selected);\n  --nest-border: var(--dv2-nest-2-border);\n  --nest-ink: var(--dv2-nest-2-ink);\n}\n\n.dv2-nested--3 {\n  --nest-head: var(--dv2-nest-3-head);\n  --nest-odd: var(--dv2-nest-3-odd);\n  --nest-even: var(--dv2-nest-3-even);\n  --nest-hover: var(--dv2-nest-3-hover);\n  --nest-selected: var(--dv2-nest-3-selected);\n  --nest-border: var(--dv2-nest-3-border);\n  --nest-ink: var(--dv2-nest-3-ink);\n}\n\n.dv2-nested--4 {\n  --nest-head: var(--dv2-nest-4-head);\n  --nest-odd: var(--dv2-nest-4-odd);\n  --nest-even: var(--dv2-nest-4-even);\n  --nest-hover: var(--dv2-nest-4-hover);\n  --nest-selected: var(--dv2-nest-4-selected);\n  --nest-border: var(--dv2-nest-4-border);\n  --nest-ink: var(--dv2-nest-4-ink);\n}\n\n.dv2-nested-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 12px;\n  background: var(--nest-head);\n  border-bottom: 1px solid var(--nest-border);\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--nest-ink);\n}\n\n.dv2-nested .dv2-table {\n  font-size: 12px;\n}\n\n.dv2-nested .dv2-table th {\n  position: static;\n  box-shadow: none;\n  cursor: pointer;\n  padding: 8px 10px;\n  background: var(--nest-head);\n  color: var(--nest-ink);\n  border-bottom-color: var(--nest-border);\n}\n\n.dv2-nested .dv2-table th.dv2-table-actions {\n  cursor: default;\n}\n\n.dv2-nested .dv2-table th:hover {\n  background: var(--nest-hover);\n}\n\n.dv2-nested .dv2-table th.dv2-table-actions:hover {\n  background: var(--nest-head);\n}\n\n.dv2-nested .dv2-table th.is-sorted {\n  color: var(--dv2-primary);\n}\n\n.dv2-nested .dv2-table td {\n  padding: 8px 10px;\n}\n\n.dv2-nested .dv2-table tbody tr:nth-child(odd) td {\n  background: var(--nest-odd);\n}\n\n.dv2-nested .dv2-table tbody tr:nth-child(even) td {\n  background: var(--nest-even);\n}\n\n.dv2-nested .dv2-table tbody tr:hover td {\n  background: var(--nest-hover);\n}\n\n.dv2-nested .dv2-table tbody tr.is-selected td {\n  background: var(--nest-selected);\n  color: var(--nest-ink);\n}\n\n.dv2-nested .dv2-table tbody tr.is-selected:hover td {\n  background: var(--nest-hover);\n}\n\n.dv2-nested .dv2-empty {\n  border: none;\n  box-shadow: none;\n  padding: 16px 12px;\n  background: var(--nest-odd);\n  color: var(--nest-ink);\n}\n\n.dv2-record-children {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: -2px 0 10px 12px;\n  padding-left: 12px;\n  border-left: 3px solid var(--nest-border, var(--dv2-border));\n}\n\n.dv2-record-children.dv2-nested--1 {\n  --nest-head: var(--dv2-nest-1-head);\n  --nest-odd: var(--dv2-nest-1-odd);\n  --nest-even: var(--dv2-nest-1-even);\n  --nest-hover: var(--dv2-nest-1-hover);\n  --nest-selected: var(--dv2-nest-1-selected);\n  --nest-border: var(--dv2-nest-1-border);\n  --nest-ink: var(--dv2-nest-1-ink);\n}\n\n.dv2-record-children.dv2-nested--2 {\n  --nest-head: var(--dv2-nest-2-head);\n  --nest-odd: var(--dv2-nest-2-odd);\n  --nest-even: var(--dv2-nest-2-even);\n  --nest-hover: var(--dv2-nest-2-hover);\n  --nest-selected: var(--dv2-nest-2-selected);\n  --nest-border: var(--dv2-nest-2-border);\n  --nest-ink: var(--dv2-nest-2-ink);\n}\n\n.dv2-record-children.dv2-nested--3 {\n  --nest-head: var(--dv2-nest-3-head);\n  --nest-odd: var(--dv2-nest-3-odd);\n  --nest-even: var(--dv2-nest-3-even);\n  --nest-hover: var(--dv2-nest-3-hover);\n  --nest-selected: var(--dv2-nest-3-selected);\n  --nest-border: var(--dv2-nest-3-border);\n  --nest-ink: var(--dv2-nest-3-ink);\n}\n\n.dv2-record-children.dv2-nested--4 {\n  --nest-head: var(--dv2-nest-4-head);\n  --nest-odd: var(--dv2-nest-4-odd);\n  --nest-even: var(--dv2-nest-4-even);\n  --nest-hover: var(--dv2-nest-4-hover);\n  --nest-selected: var(--dv2-nest-4-selected);\n  --nest-border: var(--dv2-nest-4-border);\n  --nest-ink: var(--dv2-nest-4-ink);\n}\n\n.dv2-record-children .dv2-record {\n  box-shadow: none;\n  background: var(--nest-odd, #f8fafc);\n  border-color: var(--nest-border, var(--dv2-border));\n}\n\n.dv2-record-children .dv2-record:hover {\n  background: var(--nest-hover, #e2e8f0);\n}\n\n.dv2-record-children .dv2-record.is-selected {\n  background: var(--nest-selected, #cce5ff);\n}\n\n.dv2-empty {\n  margin: 0;\n  padding: 28px 16px;\n  text-align: center;\n  color: var(--dv2-text-muted);\n  background: var(--dv2-surface);\n  border: 1px dashed var(--dv2-border);\n  border-radius: var(--dv2-radius);\n}\n\n.dv2-menuBtn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n}\n\n.dv2-menuBtn:hover,\n.dv2-menuBtn.is-open {\n  background: var(--dv2-bg);\n  color: var(--dv2-text);\n}\n\n.dv2-menu {\n  position: absolute;\n  right: 8px;\n  z-index: 400;\n  min-width: 200px;\n  padding: 6px;\n  background: #ffffff;\n  background: var(--dv2-surface, #ffffff);\n  border: 1px solid var(--dv2-border, #e2e8f0);\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);\n}\n\n.dv2-menu--fixed {\n  position: fixed;\n  right: auto;\n  z-index: 400;\n}\n\n.dv2-menu-item {\n  display: block;\n  width: 100%;\n  padding: 8px 10px;\n  text-align: left;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--dv2-text);\n  font-size: 13px;\n}\n\n.dv2-menu-item:hover {\n  background: var(--dv2-primary-soft);\n}\n\n.dv2-menu-item.is-danger {\n  color: var(--dv2-danger);\n}\n\n.dv2-menu-item.is-danger:hover {\n  background: var(--dv2-danger-soft);\n}\n\n/* Llista tipus targeta (mòbil / tauleta estreta) */\n.dv2-recordList {\n  display: none;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.dv2-record {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px;\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius);\n  box-shadow: var(--dv2-shadow);\n}\n\n.dv2-record-title {\n  margin: 0 0 4px;\n  font-weight: 700;\n}\n\n.dv2-record-meta {\n  color: var(--dv2-text-muted);\n  font-size: 12px;\n}\n\n/* ============================================================\n   Paginació\n   ============================================================ */\n\n.dv2-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 4px 2px 0;\n  color: var(--dv2-text-muted);\n  font-size: 13px;\n}\n\n.dv2-pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.dv2-pageBtn {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 8px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #334155;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.dv2-pageBtn:hover {\n  background: #e2e8f0;\n}\n\n.dv2-pageBtn.is-active {\n  background: var(--dv2-primary);\n  color: #fff;\n}\n\n.dv2-pageBtn:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.dv2-pageBtn--nav {\n  min-width: 40px;\n  height: 40px;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n/* ============================================================\n   Fitxa / formulari (Consultar, Nou, Esborrar)\n   ============================================================ */\n\n.dv2-entity {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Fitxa dins --fill: capçalera, pestanyes i botons fixos; scroll només del cos. */\n.dv2-page--fill > .dv2-entity {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.dv2-page--fill > .dv2-entity > .dv2-pageHeader,\n.dv2-page--fill > .dv2-entity > .dv2-subnav,\n.dv2-page--fill > .dv2-entity > .dv2-banner {\n  flex-shrink: 0;\n}\n\n.dv2-entity-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dv2-page--fill .dv2-entity-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.dv2-entity-dock {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-top: 10px;\n  border-top: 1px solid var(--dv2-border);\n  background: var(--dv2-bg);\n}\n\n.dv2-page--fill .dv2-entity-dock .dv2-recordNav,\n.dv2-page--fill .dv2-entity-dock .dv2-footerActions {\n  padding-top: 0;\n}\n\n.dv2-grid {\n  display: grid;\n  grid-template-columns: 1.15fr 0.85fr;\n  gap: 16px;\n}\n\n.dv2-split {\n  display: grid;\n  grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);\n  gap: 16px;\n  align-items: start;\n}\n\n.dv2-split .dv2-record {\n  width: 100%;\n  margin-bottom: 8px;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.dv2-split .dv2-record.is-selected {\n  background: #cce5ff;\n  border-color: #004085;\n}\n\n.dv2-split-tools {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 10px;\n}\n\n.dv2-split-tools .dv2-btn--mode {\n  margin-left: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n@media (max-width: 800px) {\n  .dv2-split {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dv2-grid--4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.dv2-grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.dv2-span-2 {\n  grid-column: 1 / -1;\n}\n\n.dv2-card {\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius);\n  box-shadow: var(--dv2-shadow);\n  padding: 16px 18px 18px;\n}\n\n.dv2-card-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.dv2-card-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--dv2-primary);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.dv2-card-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.dv2-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px 14px;\n}\n\n.dv2-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.dv2-field--wide {\n  grid-column: 1 / -1;\n}\n\n.dv2-field--long {\n  grid-column: span 2;\n}\n\n/* Mides semàntiques de fitxa v2. El grid uniforme de .dv2-fields (sense --sizes)\n   es queda per layouts especials, no per formularis de fitxa.\n   curt: número, pis, porta, CP, escala, dies, flags\n   mig: telèfon, cognom, població, dates, selects curts (defecte)\n   llarg: email, nom de via, web, nom comercial, selects amb botó +\n   ample: descripcions / fila sencera */\n.dv2-fields--sizes {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.dv2-fields--sizes .dv2-field {\n  flex: 0 1 14rem;\n  max-width: 20rem;\n}\n\n.dv2-fields--sizes .dv2-field--curt {\n  flex: 0 1 9rem;\n  max-width: 13rem;\n}\n\n.dv2-fields--sizes .dv2-field--mig {\n  flex: 0 1 14rem;\n  max-width: 20rem;\n}\n\n.dv2-fields--sizes .dv2-field--llarg,\n.dv2-fields--sizes .dv2-field--long {\n  flex: 1 1 22rem;\n  max-width: 34rem;\n}\n\n.dv2-fields--sizes .dv2-field--ample,\n.dv2-fields--sizes .dv2-field--wide {\n  flex: 1 1 100%;\n  max-width: none;\n}\n\n.dv2-fields--sizes .dv2-fields-break {\n  flex: 1 1 100%;\n  height: 0;\n  margin: 0;\n  pointer-events: none;\n}\n\n.dv2-path {\n  margin: 0 0 12px;\n  font-size: 13px;\n  color: var(--dv2-text-muted);\n}\n\n.dv2-path strong {\n  color: var(--dv2-text);\n  font-weight: 700;\n}\n\n.dv2-hint {\n  margin: 0 0 10px;\n  font-size: 12px;\n  color: var(--dv2-text-muted);\n}\n\n.dv2-hint--clipStart {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  direction: rtl;\n  text-align: left;\n}\n\n.dv2-hint--clipStart > span {\n  direction: ltr;\n  unicode-bidi: isolate;\n}\n\n.dv2-imagePreview {\n  display: block;\n  max-width: min(280px, 100%);\n  max-height: 180px;\n  object-fit: contain;\n  border: 1px solid var(--dv2-border);\n  border-radius: 10px;\n  background: #fff;\n  margin-bottom: 8px;\n}\n\n.dv2-steps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0 0 14px;\n  font-size: 12px;\n}\n\n.dv2-steps span {\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  color: #64748b;\n}\n\n.dv2-steps span.is-active {\n  background: var(--dv2-primary);\n  color: #fff;\n  font-weight: 700;\n}\n\n.dv2-modal--wide {\n  width: min(640px, 100%);\n  max-height: min(86vh, 720px);\n  overflow-y: auto;\n}\n\n.dv2-modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.dv2-modal-head .dv2-modal-title {\n  flex: 1;\n  min-width: 0;\n  padding-top: 4px;\n}\n\n.dv2-modal--wide > .dv2-modal-head {\n  position: sticky;\n  top: -20px;\n  z-index: 2;\n  background: var(--dv2-surface);\n  margin: -20px -22px 12px;\n  padding: 16px 14px 12px 22px;\n  border-bottom: 1px solid var(--dv2-border);\n}\n\n.dv2-controlRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.dv2-controlRow .dv2-select,\n.dv2-controlRow .dv2-input,\n.dv2-controlRow .dv2-value {\n  flex: 1;\n  min-width: 0;\n}\n\n.dv2-btn--compact {\n  min-height: 38px;\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n.dv2-modalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.dv2-modal {\n  width: min(420px, 100%);\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius);\n  box-shadow: var(--dv2-shadow-md);\n  padding: 20px 22px 18px;\n}\n\n.dv2-modal-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.dv2-modal-lead {\n  margin: 6px 0 16px;\n  color: var(--dv2-text-muted);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.dv2-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.dv2-help {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dv2-help-section h4 {\n  margin: 0 0 6px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--dv2-text);\n}\n\n.dv2-help-section p,\n.dv2-help-section li {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--dv2-text-muted);\n}\n\n.dv2-help-section p + p,\n.dv2-help-section p + ul {\n  margin-top: 6px;\n}\n\n.dv2-help-section ul {\n  margin: 0;\n  padding-left: 1.2rem;\n}\n\n.dv2-help-section li + li {\n  margin-top: 4px;\n}\n\n.dv2-hint {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: var(--dv2-text-muted);\n}\n\n.dv2-combo {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n}\n\n.dv2-combo-list {\n  position: absolute;\n  z-index: 30;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  max-height: 220px;\n  overflow-y: auto;\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border-strong);\n  border-radius: var(--dv2-radius-sm);\n  box-shadow: var(--dv2-shadow-md);\n}\n\n.dv2-combo-option {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.dv2-combo-option:hover,\n.dv2-combo-option.is-active {\n  background: var(--dv2-primary-soft);\n}\n\n.dv2-label {\n  font-size: 12px;\n  font-weight: 650;\n  color: #334155;\n}\n\n.dv2-value {\n  min-height: 22px;\n  color: var(--dv2-text);\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.dv2-required::after {\n  content: \" *\";\n  color: var(--dv2-danger);\n}\n\n.dv2-toggleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 38px;\n}\n\n.dv2-toggleGroup {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 28px;\n  min-height: 38px;\n}\n\n.dv2-toggle {\n  position: relative;\n  width: 42px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.dv2-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.dv2-toggle-track {\n  position: absolute;\n  inset: 0;\n  background: #cbd5e1;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.dv2-toggle-track::after {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  background: #fff;\n  box-shadow: var(--dv2-shadow);\n  transition: transform 0.15s ease;\n}\n\n.dv2-toggle input:checked + .dv2-toggle-track {\n  background: var(--dv2-primary);\n}\n\n.dv2-toggle input:checked + .dv2-toggle-track::after {\n  transform: translateX(18px);\n}\n\n.dv2-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 650;\n  background: var(--dv2-bg);\n  color: #334155;\n}\n\n.dv2-chip--ok {\n  background: var(--dv2-success-soft);\n  color: #166534;\n}\n\n.dv2-chip--warn {\n  background: #fffbeb;\n  color: #92400e;\n}\n\n.dv2-chip--danger {\n  background: var(--dv2-danger-soft);\n  color: #991b1b;\n}\n\n/* Miniatura d'imatge de recurs (Vehicles, Eines, Magatzems) */\n.dv2-thumb {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--dv2-border);\n  border-radius: 8px;\n  background: var(--dv2-bg);\n  color: var(--dv2-text-muted);\n  font-size: 18px;\n  overflow: hidden;\n}\n\n.dv2-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.dv2-record-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.dv2-imageField {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.dv2-imageField .dv2-imagePreview {\n  margin-bottom: 0;\n}\n\n.dv2-banner--info {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1e3a8a;\n}\n\n.dv2-table tbody tr.is-inactive td {\n  color: var(--dv2-text-muted);\n}\n\n.dv2-banner {\n  display: flex;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: var(--dv2-radius);\n  border: 1px solid transparent;\n  font-size: 13px;\n}\n\n.dv2-banner--danger {\n  background: var(--dv2-danger-soft);\n  border-color: #fecaca;\n  color: #991b1b;\n}\n\n.dv2-contactPick {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: var(--dv2-surface);\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius);\n}\n\n.dv2-contactPick-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border: 1px solid var(--dv2-border);\n  border-radius: 10px;\n  background: var(--dv2-surface-muted);\n}\n\n.dv2-footerActions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  padding-top: 8px;\n}\n\n.dv2-recordNav {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  padding-top: 4px;\n}\n\n.dv2-recordNav-btn {\n  min-width: 44px;\n  min-height: 44px;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1;\n  padding: 0;\n}\n\n.dv2-recordNav-info {\n  min-width: 4.5rem;\n  text-align: center;\n  color: var(--dv2-text-muted);\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;\n}\n\n.dv2-subnav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 0 4px;\n  border-bottom: 1px solid var(--dv2-border);\n}\n\n.dv2-subnav-btn {\n  appearance: none;\n  border: none;\n  background: none;\n  padding: 10px 14px;\n  margin-bottom: -1px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.dv2-subnav-btn:hover {\n  color: var(--dv2-text);\n}\n\n.dv2-subnav-btn:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.dv2-subnav-btn:disabled:hover {\n  color: #94a3b8;\n}\n\n.dv2-subnav-btn.is-active {\n  color: var(--dv2-primary);\n  border-bottom-color: var(--dv2-primary);\n}\n\n.dv2-specList {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border: 1px solid var(--dv2-border);\n  border-radius: var(--dv2-radius);\n  overflow: hidden;\n  background: var(--dv2-surface);\n}\n\n.dv2-spec {\n  display: grid;\n  grid-template-columns: minmax(140px, 1.2fr) minmax(160px, 1.4fr);\n  gap: 8px 16px;\n  padding: 10px 14px;\n  align-items: baseline;\n  border-bottom: 1px solid var(--dv2-border);\n}\n\n.dv2-spec:nth-child(even) {\n  background: var(--dv2-surface-muted);\n}\n\n.dv2-spec:last-child {\n  border-bottom: none;\n}\n\n.dv2-spec-name {\n  font-weight: 650;\n  color: #334155;\n}\n\n.dv2-spec-value {\n  color: var(--dv2-text);\n  font-variant-numeric: tabular-nums;\n}\n\n.dv2-spec-unit {\n  color: var(--dv2-text-muted);\n  font-weight: 600;\n}\n\n.dv2-editorRow {\n  display: grid;\n  grid-template-columns: minmax(160px, 1.4fr) minmax(90px, 0.7fr) minmax(70px, 0.5fr) minmax(70px, 0.5fr) 90px 40px;\n  gap: 8px;\n  align-items: end;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--dv2-border);\n}\n\n.dv2-editorRow .dv2-field {\n  min-width: 0;\n}\n\n@media (max-width: 900px) {\n  .dv2-spec,\n  .dv2-editorRow {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n/* ============================================================\n   Adaptació (escriptori estret / tauleta / mòbil)\n   El menú hamburguesa cal JS; aquí només amaga/ensenya.\n   ============================================================ */\n\n@media (max-width: 1400px) {\n  .dv2-nav-burger {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .dv2-nav-list {\n    display: none;\n  }\n\n  .dv2-nav-scrim {\n    display: block;\n    position: fixed;\n    inset: var(--dv2-nav-h) 0 0 0;\n    background: rgba(15, 23, 42, 0.28);\n    z-index: 25;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n\n  .dv2-nav.is-open .dv2-nav-list {\n    display: flex;\n    position: absolute;\n    top: var(--dv2-nav-h);\n    left: 0;\n    right: 0;\n    height: auto;\n    max-height: calc(100vh - var(--dv2-nav-h));\n    overflow-y: auto;\n    flex-direction: column;\n    align-items: stretch;\n    padding: 8px;\n    background: var(--dv2-surface);\n    border-bottom: 1px solid var(--dv2-border);\n    box-shadow: var(--dv2-shadow-md);\n    z-index: 30;\n  }\n\n  .dv2-nav.is-open .dv2-nav-item {\n    height: 40px;\n    justify-content: flex-start;\n    border-bottom: none;\n    border-radius: 8px;\n  }\n\n  .dv2-nav.is-open .dv2-nav-dropdown {\n    flex-direction: column;\n    height: auto;\n    align-items: stretch;\n  }\n\n  .dv2-nav.is-open .dv2-nav-dropdown .dv2-nav-menu {\n    position: static;\n    display: none;\n    min-width: 0;\n    border: none;\n    box-shadow: none;\n    padding: 0 0 6px 12px;\n  }\n\n  .dv2-nav.is-open .dv2-nav-dropdown.is-open .dv2-nav-menu {\n    display: block;\n  }\n\n  .dv2-nav.is-open .dv2-nav-dropdown:hover .dv2-nav-menu {\n    display: none;\n  }\n\n  .dv2-nav.is-open .dv2-nav-dropdown.is-open:hover .dv2-nav-menu {\n    display: block;\n  }\n\n  .dv2-grid,\n  .dv2-grid--3,\n  .dv2-grid--4 {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .dv2-page {\n    padding: 14px 12px 24px;\n  }\n\n  .dv2-page--fill {\n    height: calc(100vh - 96px);\n    max-height: calc(100vh - 96px);\n    padding: 12px 10px 8px;\n  }\n\n  .dv2-pageHeader {\n    flex-direction: column;\n  }\n\n  .dv2-pageHeader-actions,\n  .dv2-filterBar {\n    width: 100%;\n  }\n\n  .dv2-tableWrap {\n    display: block;\n    max-width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .dv2-recordList {\n    display: flex;\n  }\n\n  .dv2-grid,\n  .dv2-grid--3,\n  .dv2-grid--4 {\n    grid-template-columns: 1fr;\n  }\n\n  .dv2-field--long {\n    grid-column: 1 / -1;\n  }\n\n  .dv2-fields--sizes .dv2-field:not(.dv2-field--curt) {\n    flex: 1 1 100%;\n  }\n\n  .dv2-fields--sizes .dv2-field--curt {\n    flex: 1 1 calc(50% - 7px);\n    max-width: none;\n  }\n\n  .dv2-nav-user-text,\n  .dv2-nav-brand-name,\n  .dv2-nav-logout-text {\n    display: none;\n  }\n\n  .dv2-nav-logout {\n    width: 36px;\n    padding: 0;\n  }\n\n  .dv2-pagination {\n    justify-content: center;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .dv2 *,\n  .dv2 *::before,\n  .dv2 *::after {\n    transition: none !important;\n  }\n}\n\n@media print {\n  @page {\n    margin: 12mm;\n  }\n\n  body {\n    background: #fff !important;\n  }\n\n  .dv2-nav,\n  .menu-bar,\n  .action-toolbar,\n  .dv2-nav-scrim {\n    display: none !important;\n  }\n\n  .Dashboard {\n    display: block !important;\n    height: auto !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n    background: #fff !important;\n  }\n\n  .content {\n    display: block !important;\n    padding: 0 !important;\n    border: none !important;\n    overflow: visible !important;\n    height: auto !important;\n    max-height: none !important;\n    background: #fff !important;\n  }\n\n  .dv2-page,\n  .dv2-page--fill,\n  .dv2-listBody,\n  .dv2-tableWrap,\n  .dv2-recordList,\n  .dv2-entity-body,\n  .Dashboard-table-container,\n  .Dashboard-content {\n    height: auto !important;\n    max-height: none !important;\n    overflow: visible !important;\n  }\n\n  .dv2-tableWrap {\n    display: block !important;\n    box-shadow: none !important;\n  }\n\n  .dv2-recordList {\n    display: none !important;\n  }\n\n  .dv2-table th {\n    position: static !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
